import axios from 'axios';

const addNewIngredientApi = async (token, values, edit = false) => {
  try {
    let url;
    if (!edit) url = '/StockMaterial/create';
    else url = '/StockMaterial/update';

    const res = await axios.post(url, values, {
      headers: {
        lang: 'ar',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default addNewIngredientApi;
